import * as config from "../config.json";

export default class Config {
  public static getConfig<T>(
    section: T extends keyof typeof config ? T : keyof typeof config,
  ) {
    return config[section];
  }
}
